import axios from 'axios';

export default {
  getToken() {
    return localStorage.getItem('user-token');
  },
  async getOriginSystems(params = {}) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/origin-systems`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params,
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createOriginSystem(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/origin-systems`,
        {
          name: payload.name,
          key: payload.key,
          is_active: payload.isActive,
        },
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateOriginSystem(id, payload) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/origin-systems/${id}`,
        {
          name: payload.name,
          key: payload.key,
          is_active: payload.isActive,
        },
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteOriginSystem(id) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_VIDA_URL}/origin-systems/${id}`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
